export interface FormState {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  password: string;
  avatar: any;
}

export function createEmptyFormState() : FormState {
  return {
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    password: '',
    avatar: {},
  };
}
